module.exports = {
  "country": "GR",
  "artist": "Marina Satti",
  "song": "Zari",
  "year": "2024",
  "place": "11",
  "spotify": "3wRgk5tGQzfNXtSawH8O3S"
};